import { useContext, useRef } from 'react'
import axios from 'axios';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { profile, imageLocation, updateProfile, imageUpload, deleteImage } from '../../../Context/api';
import { Notifications } from '../../../App';


const UseProfile = () => {
    const [image, setImage] = useState()
    const { setUserInfo } = useContext(Notifications)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const fileInputRef = useRef(null);

    useEffect(() => {
        getBasicProfileDetails()
    }, [])

    const uploadImage = (e) => {
        const fd = new FormData()
        fd.append('file', e)
        fd.append('type', 'PROFILE')
        axios.post(imageUpload(), fd).then((res) => {
            if (res.data.code === 200) {
                setImage(res.data.data.imagePath)
                fileInputRef.current.value = null;
            }
        })
    }
    const imageDelete = () => {
        const data = {
            userId: adminData?.userId,
            fileName: image,
            type: 'PROFILE',
        };

        axios.post(deleteImage(), { ...data }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                getBasicProfileDetails()
                toast.success(resp.data.message);
                let data = JSON.parse(localStorage.getItem('adminData'))
                let updateData = { ...data }
                updateData.image = ''
                localStorage.setItem("adminData", JSON.stringify(updateData))
                setUserInfo(JSON.parse(localStorage.getItem('adminData')))
            } else {
                toast.error(resp.data.message);
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError);
            });
    };
    const getBasicProfileDetails = () => {
        axios
            .post(profile(), { userId: adminData.userId })
            .then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    setImage(resp.data.data.image)
                    profiles.setValues(resp.data.data)

                }
            })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const profiles = useFormik({
        initialValues: {
            name: '',
            email: '',
            mobileNo: '',

        },
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                email: values.email.trim(),
                mobileNo: values.mobileNo,
                timeZone: timeZone,
                image: image,
                userId: adminData.userId,
                roleTitle: adminData.roleTitle
            }
            axios.post(updateProfile(), { ...data }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    let data = JSON.parse(localStorage.getItem('adminData'))
                    let updateData = { ...data }
                    updateData.image = image
                    updateData.name = values.name.trim()
                    localStorage.setItem("adminData", JSON.stringify(updateData))
                    setUserInfo(JSON.parse(localStorage.getItem('adminData')))
                } else {
                    toast.error(resp.data.message)
                    getBasicProfileDetails()
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })
        }
    })
    return {
        uploadImage,
        imageDelete,
        image,
        profiles,
        fileInputRef,
        imageLocation

    }
}

export default UseProfile